import { get, post } from '../services/common/common.service';
import { entitlementsEndPoints } from '../constants/endpoint';

//Entitlement Search By ID - GET API to fetch the data
export const fetchEntitlementsSearchById = (payload) => {
  return get(
    `${entitlementsEndPoints.entitlementsSearchById}?entitlementId=${payload}`,
    payload
  );
};

//Entitlement Search Grid Data - POST API to fetch the data
export const fetchEntitlementsSearchGridData = (payload) => {
  return post(entitlementsEndPoints.entitlementsSearch, payload); 
};

//Entitlement Site History - GET API to fetch the data
export const fetchEntitlementsSiteHistoryById = (payload) => {
  return get(
    `${entitlementsEndPoints.entitlementSiteHistory}?entitlementId=${payload.entitlementId}&RecordCount=${payload.RecordCount}&PageIndex=${payload.PageIndex}`,
    payload
  );
};

//Search Options

//Accounting Group Smart Seach - POST API to fetch the data as per payload
export const fetchAccountingGroupsData = (payload) => {
  return post(entitlementsEndPoints.accountingGroup, payload);  
};

//Get Customer Details for Global Customer Code Search - GET API to fetch the data as per payload
export const fetchGlobalCustomersNo = (payload) => {    
  return get(
    `${entitlementsEndPoints.customersByGlobalCustomersNo}?globalCustomerNumber=${payload}`
  );  
};

//Get Customers List On Grid - POST API to fetch the data as per payload
export const fetchentitlementsCustomerSearchByName = (payload) => {        
  return post(entitlementsEndPoints.entitlementsCustomerSearchByName, payload);  
};

//Get Customers List On Grid - POST API to fetch the data as per payload
export const fetchentitlementsCustomerSearch = (payload) => {        
  return post(entitlementsEndPoints.entitlementsCustomerSearch, payload);  
};

//Get Customers List On Grid - POST API to fetch the data as per payload
export const byMultipleInputs = (payload) => {
  return post(entitlementsEndPoints.entitlementsbyMultipleInputs, payload);
};

//Customer Smart Seach - POST API to fetch the data as per payload
export const fetchSites = (payload) => {
  return post(entitlementsEndPoints.entitlementsSite, payload);
};

//Customer Smart Seach - POST API to fetch the data as per payload
export const searchProductCodeName = (payload) => {
  return post(entitlementsEndPoints.entitlementsServiceProducts, payload);
};

export const fetchEntitlementsStatus = (payload) => {
  return get(entitlementsEndPoints.entitlementsStatus, payload);
};

export const fetchEntitlementsType = (payload) => {
  return get(entitlementsEndPoints.entitlementsType, payload);
};